import { BsCloudCheckFill, BsCloudSlashFill } from "react-icons/bs";
import { CustomTooltip } from "./tooltip";
import { type Translationtype } from "utils";

interface IUploadedStatusProps {
  t: Translationtype;
  status: boolean;
  className?: string;
}

export function UploadedStatus({ t, status, className }: IUploadedStatusProps) {
  if (status === null) {
    return null;
  }

  return (
    <div
      className={`${
        className || ""
      }  rounded-xl backdrop-blur-sm bg-gray-100/20 h-[30px] p-[3px]`}
    >
      {status ? (
        <CustomTooltip
          text={t("Devices.greetingsTeaserUpToDate")}
          className="w-[200px]"
        >
          <BsCloudCheckFill className="text-2xl text-[#23951d]" />
        </CustomTooltip>
      ) : (
        <CustomTooltip
          text={t("Devices.greetingsTeaserNotUpToDate")}
          className="w-[200px]"
        >
          <BsCloudSlashFill className="text-2xl text-[#ff1b1b]" />
        </CustomTooltip>
      )}
    </div>
  );
}
